import { Button, Form, Modal, Row, Tabs } from 'antd'
import OrdersApi from '../../../../api/Sales/Orders'
import PartnerOrder from '../../../../components/Sales/Orders/OnlineSalesOrder/ViewOnlineOrder/partnerOrder'
import WordpressOrder from '../../../../components/Sales/Orders/OnlineSalesOrder/ViewOnlineOrder/WordpressOrder'
import useSubmit from '../../../../elements/Hooks/useSubmit'

import React from 'react'
import { useHistory } from 'react-router-dom'

const api = new OrdersApi()

function OnlineSalesModal(props) {
  const { visible, onCancel, line, fetch, readonly = false } = props

  let history = useHistory()

  const type = line.realm
  const isClearFog = type === 'https://clearfog.co.uk'
  const isCleanMist = type === 'https://cleanmist.com.au'

  console.log(line)
  const [submittingStatus, onProcess] = useSubmit(async (ref) => {
    await api.updateOnlineOrderAPI({ status: 'Invoiced', ref }, line._key)
    fetch()
    onCancel()
  })

  const [submitting, onSubmit] = useSubmit(async () => {
    const data = await api.createWithOnline(line)
    console.log(data)
    if (data.sales._key) {
      await onProcess(data.sales._key)
      history.push({
        pathname: `/clients/orders/${data.sales._key}/update`,
      })
    }
  })

  return (
    <Modal visible={visible} title={'Online Order'} onCancel={onCancel} destroyOnClose={true} width={'85%'}>
      {!readonly && (
        <>
          <Button
            style={{
              marginLeft: '10px',
              marginBottom: '10px',
            }}
            loading={submitting || submittingStatus}
            onClick={onSubmit}
            type="primary">
            Create Sales Order
          </Button>
        </>
      )}
      {/*{line.status !== 'possessed' && (*/}
      {/*  <Button*/}
      {/*    style={{*/}
      {/*      marginLeft: '10px',*/}
      {/*      marginBottom: '10px'*/}
      {/*    }}*/}
      {/*    loading={submittingStatus}*/}
      {/*    onClick={onProcess}*/}
      {/*    type="primary">*/}
      {/*    Mark As Processed*/}
      {/*  </Button>*/}
      {/*)}*/}
      {(isClearFog || isCleanMist) ? <WordpressOrder line={line} /> : <PartnerOrder order={line.order} />}
    </Modal>
  )
}

export default OnlineSalesModal
